module.exports = __webpack_public_path__ + "static/media/check_green.57007be7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/check_green.svg
// module id = 75
// module chunks = 0